// export enum ProductCode {
// 	COMPREHENSIVE_AUTO = 2,
// 	MINI_COMPREHENSIVE = 4,
// 	THIRD_PARTY = 1,
// 	MONTHLY_COMPREHENSIVE = 14,
// 	ACCESS_PLAN = 21,

// 	GADGET = 5,
// 	LAPTOP_COVER = 30,
// 	TRAVEL_ALLIANZ = 29,
// 	TRAVEL_AIICO = 6,

// 	FLEXICARE_BASTION_BUSINESS = 31,
// 	FLEXICARE_MINI_HYGEIA_PROD = 32,
// 	FLEXICARE_PLUS = 26,
// 	FLEXICARE_BASTION_BUSINESS = 38,
// 	FLEXICARE_BASTION_PERSONAL = 9,
// 	FLEXICARE_MINI_BASTION_BUSINESS = 32,
// 	FLEXICARE_MINI_BASTION_BUSINESS = 39,
// 	FLEXICARE_BASTION_PERSONAL = 20,

// 	ZENCARE_PLUS_BASTION_PERSONAL = 16,
// 	ZENCARE_PRIME_BASTION_PERSONAL = 18,

// 	ZENCARE_BASTION_PERSONAL = 17,
// 	ZENCARE_BASTION_BUSINESS = 33,

// 	ZENCARE_PLUS_BASTION_BUSINESS = 34,
// 	ZENCARE_PRIME_BASTION_BUSINESS = 35,

// 	ZENCARE_SENIOR_CITIZEN = 22,
// 	ZENCARE_SENIOR_CITIZEN_WAITING = 23,
// 	ZENCARE_PLUS_SENIOR_CITIZEN = 24,
// 	ZENCARE_PLUS_SENIOR_CITIZEN_WAITING = 25,

// 	PRIMECARE_BASTION_PERSONAL = 27,
// 	PRIMECARE_PLUS_BASTION_BUSINESS = 28,
// 	PRIMECARE_BASTION_BUSINESS = 36,
// 	PRIMECARE_PLUS_BASTION_BUSINESS = 37,

// 	SENIORS_PLAN_BASTION = 40,
// 	SENIORS_PLAN_PLUS_BASTION = 41,
// 	SENIORS_PLAN_PRIME_BASTION = 42
// }
export const PRODUCT_IDS = {
	FLEXICARE_RETAIL: '7105b52b-07da-4ccc-abee-3255b78ce33a',
	FLEXICARE_MINI_RETAIL: '8bb596f1-eedc-489a-9b04-6b2381f7b79e',
	FLEXICARE_BUSINESS: 'eed264d7-1124-4fb5-8231-b4f3b976e4ff',
	FLEXICARE_MINI_BUSINESS: 'f18aa7d6-d330-42df-9143-3dc0da762a8a'
}
export const productGuideId = 29
export const nairaSign = <T = string>(val: string | number, isForeign?: boolean) => {
	if (typeof val === 'string' || typeof val === 'number') {
		let amount = val
		// Math.round(val)
		if (!isNaN(amount as number)) {
			amount = Math.round(val as number)
		}

		amount = String(amount)
			.replace(/\D/g, '')
			.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
		return (isForeign ? '$' : '₦' + amount) as T
	}
	return val as T
}
export enum ProductGroupName {
	FLEXICARE_BASTION_BUSINESS = 'flexicare',
	ZENCARE = 'zencare',
	PRIMECARE = 'primecare',
	SENDCARE = 'senior',
	GADGET = 'gadget'
}
export enum HealthAgeLimit {
	HYGEIA = 75,
	BASTION = 70,
	BASTION_SENIOR = 85
}
export const CoverPeriodMap: Record<string, string> = {
	annual: 'anually',
	monthly: 'monthly',
	'bi-anuall': 'bi-annually',
	quarterly: 'quarterly'
}

export const WPBaseUrl = 'https://blog-cms.mycovergenius.com/wp-json/wp/v2'
interface Support {
	linkText: string
	link: string
	line?: string
	mail?: string
	health_line?: 'hygeia' | 'bastion' | 'both'
	icon: string
	type: 'whatsapp' | 'email' | 'manager' | 'doctor' | 'call'
	target?: '_blank' | '_window'
}

export const supportLines: Support[] = [
	{
		type: 'doctor',
		linkText: '+234 800 043 2584',
		link: 'tel:+2348000432584',
		line: '+2348000432584',
		health_line: 'hygeia',
		icon: 'phone'
	},
	{
		type: 'doctor',
		linkText: 'bastion link',
		link: 'http://vhp.heala.io/mycoverai',
		line: 'http://vhp.heala.io/mycoverai',
		health_line: 'bastion',
		icon: 'link'
	},
	{
		type: 'manager',
		linkText: '+234 907 0008 899',
		link: 'tel:+2349070008899',
		line: '+2349070008899',
		icon: 'phone'
	},

	{
		type: 'email',
		linkText: 'chat with support',
		link: 'mailto:support@mycovergenius.com',
		mail: 'support@mycovergenius.com',
		icon: 'mail',
		target: '_blank'
	},
	{
		type: 'whatsapp',
		linkText: '+234 808 8188 002',
		link: 'https://wa.link/xtmmw8',
		icon: 'whatsapp',
		target: '_blank'
	},
	{
		type: 'whatsapp',
		linkText: '+234 907 0008 899',
		link: 'https://wa.link/2ybz6z',
		icon: 'whatsapp',
		target: '_blank'
	}
]
